import { createFileRoute } from '@tanstack/react-router';

import { ensureRecord } from '@/app/guards';
import { EmployerPage, employerQuery } from '@/features/employers';
import { NotFoundView } from '@/features/shell';

export const Route = createFileRoute('/_app/employers/$employerId')({
  loader: async ({ context, params }) => {
    const e = await ensureRecord(context.queryClient.query({ ...employerQuery(params.employerId), staleTime: 'static' }));
    return { crumb: e.name };
  },
  notFoundComponent: function RecordNotFound() {
    const { employerId } = Route.useParams();
    return <NotFoundView reference={employerId} />;
  },
  component: function Employer() {
    const { employerId } = Route.useParams();
    return <EmployerPage employerId={employerId} />;
  },
});
